import { Component, ElementRef, ViewChild } from '@angular/core';

interface ToastAttribute {
  success: boolean;
  message: string;
  dismissable?: boolean;
  duration?: number;
}

@Component({
  standalone: false,
  selector: 'app-toast',
  templateUrl: './toast.component.html',
  styleUrls: ['./toast.component.scss']
})
export class ToastComponent {
  @ViewChild('wdprtoast') wdprtoast: ElementRef;
  toastAttr: ToastAttribute = {
    success: true,
    message: '',
    dismissable: true
  };

  open(message: string, success = true) {
    this.toastAttr.message = message;
    this.toastAttr.success = success;
    this.wdprtoast.nativeElement.open();
  }

  close() {
    this.toastAttr.message = '';
    this.toastAttr.success = true;
    this.wdprtoast.nativeElement.close();
  }
}
